import api from './api';

const adminService = {
  // Dashboard
  getDashboard: () => api.get('/admin/dashboard'),

  // Sellers
  getSellers: (page = 1, limit = 10) =>
    api.get('/admin/sellers', { params: { page, limit } }),

  createSeller: (data) => api.post('/admin/sellers', data),

  updateSeller: (id, data) => api.put(`/admin/sellers/${id}`, data),

  deleteSeller: (id) => api.delete(`/admin/sellers/${id}`),

  assignRegion: (seller_id, region_id) =>
    api.post('/admin/sellers/assign-region', { seller_id, region_id }),

  // Orders
  getAllOrders: (params) => api.get('/admin/orders', { params }),

  // Statistics
  getStatistics: (params) => api.get('/admin/statistics', { params }),
};

export default adminService;
